// Posts Store
import { clone, findIndex, filter } from 'lodash'
import { getField, updateField } from 'vuex-map-fields'
import { displayUserName } from '@/helper'
import store from 'customerPath/store'

const post = {
  description: null,
  options: {},
  preview: {},
  files: [],
  author: null,
}

const state = {
  authors: [],
  selectOptions: [],
  pending: false,
  pendingPreview: false,
  post: clone(post),
  users: [],
}

const getters = {
  getField,
}

const actions = {
  deletePost({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items
      .deleteItem(`posts.${id}`)
      .then(({ data }) => {
        commit('DELETE_POST')
        resolve(data)
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
  deleteFile({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items.deleteItem(`posts.file.${id}`)
      .then(({ data }) => {
        commit('DELETE_POST_FILE')
        resolve(data)
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
  getAuthors({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items.getItems('posts/authors')
      .then(({ data }) => {
        commit('SET_AUTHORS', data)
        resolve()
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
  getOptions({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items.getItems('posts/options')
      .then(({ data }) => {
        commit('SET_OPTIONS', data)
        resolve()
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
  getTopicOptions({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items.getItem(`posts.options.${id}`)
      .then(({ data }) => {
        commit('SET_TOPIC_OPTIONS', data)
        resolve()
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
  getOptionsForGroup({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items.getItem(`posts.options.${id}`)
      .then(({ data }) => {
        commit('SET_OPTIONS_FOR_GROUP', data)
        resolve()
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
  getOptionsForTopic({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items.getItem(`posts.options.${id}`)
      .then(({ data }) => {
        commit('SET_OPTIONS_FOR_TOPIC', data)
        resolve()
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
  getLinkPreview({ commit }, url) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING', true)
      commit('SET_PENDING_PREVIEW', true)
      this.api.items.getLinkPreview(url)
      .then(({ data }) => {
        commit('SET_LINK_PREVIEW', data)
        resolve()
      })
      .catch(_ => {
        reject()
      })
      .finally(_ => {
        commit('SET_PENDING_PREVIEW', false)
        commit('SET_PENDING', false)
      })
    })
  },
  createPost({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING', true)
      this.api.items.createItem('posts', state.post)
      .then(({ data }) => {
        if (data.status && data.status === -1) {
          resolve(data.status)
        }
        commit('CREATE_POST')
        commit('RESET_POST')
        resolve(data)
      })
      .catch(({ response }) => {
        store.dispatch('app/setError', response.status)
        reject(response)
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
  clearUsers({ commit }) {
    commit('CLEAR_USERS')
  },
  removeMedia({ commit }) {
    commit('REMOVE_MEDIA')
  },
  removePreview({ commit }) {
    commit('REMOVE_PREVIEW')
  },
  removeTopics({ commit }) {
    commit('REMOVE_TOPICS')
  },
  updatePostOptions({ commit }, data) {
    commit('UPDATE_POST_OPTIONS', data)
  },
  deleteComment({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items
      .deleteItem(`comments.${id}`)
      .then(({ data }) => {
        commit('DELETE_COMMENT')
        resolve(data)
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
}

const mutations = {
  SET_PENDING: (state, status) => {
    state.pending = status
  },
  SET_PENDING_PREVIEW: (state, status) => {
    state.pendingPreview = status
  },
  RESET_POST(state) {
    state.post = clone(post)
  },
  CLEAR_USERS(state) {
    state.users = []
  },
  REMOVE_PREVIEW(state) {
    state.post.preview = {}
  },
  REMOVE_MEDIA(state) {
    state.post.preview.video_url = ''
    state.post.preview.image = ''
    state.post.preview.image_url = ''
  },
  SET_LINK_PREVIEW: (state, { data }) => {
    state.post.preview = data
  },
  UPDATE_POST_OPTIONS: (state, payload) => {
    state.post.options = payload
  },
  SET_AUTHORS: (state, payload) => {
    const authors = []
    payload.forEach(author => {
      authors.push({ id: author.id, name: displayUserName(author) })
    })
    state.authors = authors
  },
  SET_OPTIONS: (state, payload) => {
    state.selectOptions = payload
  },
  SET_TOPIC_OPTIONS: (state, payload) => {
    const topicIndex = findIndex(state.selectOptions, o => o.id === payload[0].id)
    if (topicIndex === -1) {
      state.selectOptions.splice(1, 0, payload[0])
    } else {
      state.selectOptions.splice(topicIndex, 1, payload[0])
    }
  },
  SET_OPTIONS_FOR_GROUP: (state, payload) => {
    state.selectOptions = payload
  },
  SET_OPTIONS_FOR_TOPIC: (state, payload) => {
    state.selectOptions = payload
    state.selectOptions = filter(state.selectOptions, o => o.identifier !== 'topics')
  },
  REMOVE_TOPICS: state => {
    state.selectOptions = filter(state.selectOptions, o => o.identifier !== 'topics')
  },
  updateField,
}

/*
 * This commits are only for the vuex history (visible in the vue devtools tab 2)
 * if you need to store data with any history commit, then remove the commit from
 * the history_commits and create a new commit in the mutation block.
 */
const history_commits = [
  'DELETE_POST',
  'CREATE_POST',
  'DELETE_POST_FILE',
  'DELETE_COMMENT',
]

history_commits.forEach(commit => {
  mutations[commit] = _ => true
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
